export interface CateringPreferenceOption {
  value: string;
  label: string;
}

export const DUNA_CATERING_PREFERENCE_OPTIONS: CateringPreferenceOption[] = [
  { value: 'nothing', label: 'Ingen specielle ønsker' },
  { value: 'glutenfri', label: 'Glutenfri' },
  { value: 'hallal', label: 'Halal' },
  { value: 'vegetar', label: 'Vegetar' },
  { value: 'veganer', label: 'Veganer' },
  { value: 'laktose', label: 'Laktose' },
  { value: 'nodder', label: 'Nødder' }
];

/** Legacy stored values (join form / user profile) → canonical option values. */
export function mapLegacyCateringPreferenceValue(value: string): string {
  switch ((value || '').trim()) {
    case 'ingen_praeferencer':
      return 'nothing';
    case 'halal':
      return 'hallal';
    default:
      return (value || '').trim();
  }
}

/** Same rules as catering-wishes: selecting "nothing" clears other choices. */
export function normalizeCateringPreferenceSelection(values: string[]): string[] {
  const cleaned = (values || [])
    .map((value) => mapLegacyCateringPreferenceValue(value))
    .filter((value) => value.length > 0);
  if (cleaned.includes('nothing')) {
    return ['nothing'];
  }
  return Array.from(new Set(cleaned)).sort((a, b) => a.localeCompare(b));
}

/** Map participate-form checkbox values to API participant storage (matches PHP normalize). */
export function mapParticipateFormChoicesToStoredPreferences(
  cateringChoices: string | string[] | null | undefined
): string[] {
  const raw = Array.isArray(cateringChoices)
    ? cateringChoices
    : cateringChoices != null && String(cateringChoices).trim() !== ''
      ? [String(cateringChoices)]
      : [];
  const formValues = normalizeCateringPreferenceSelection(raw);
  return formValues.map((choice) => {
    switch (choice) {
      case 'nothing':
        return 'ingen_praeferencer';
      case 'hallal':
        return 'halal';
      default:
        return choice;
    }
  });
}
